import React,{useRef} from 'react';
import { Component } from 'react';
import ReactDOM from 'react-dom';

import Header from "../components/header";
import Float from "../components/float";
import Modals from "../components/modals";
import Footer from "../components/footer";

import Info from "../components/cart/info";

export default class Cart extends Component {
    constructor(props){
        super(props)

        this.state = {
            name: '',
            products_cart: [],
            products:[],
            formCart:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            shipping:0,
            addressList:[],
            formAddress:{
                id:'',
                password:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            formAddressAdd:{
                id:'',
                password:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            city_id:0,
            error: null,
            brands:[],
            brands_2:[],
            categories:[],
            info:[],
            formRegister:{
                name:'',
                lastname:'',
                identy:'',
                mail:'',
                password:'',
                phone:'',
                address:'',
                town:'',
                token:'',
                country_id:'',
                state_id:'',
                city_id:'',
                description:''
            },
            countries:[],
            states:[],
            cities:[],
            formLogin:{
                user:'',
                password:'',
                token:'',
            },
        }

        this.formRegisterSubmit = this.formRegisterSubmit.bind(this)
        this.handleChangeFormRegister = this.handleChangeFormRegister.bind(this)
        this._recaptchaRefRegister = React.createRef();
        this.onChangeCountry = this.onChangeCountry.bind(this)
        this.onChangeState = this.onChangeState.bind(this)
        this.onChangeCity = this.onChangeCity.bind(this)

        this.forget = this.forget.bind(this);
        this.formLoginSubmit = this.formLoginSubmit.bind(this)
        this.handleChangeFormLogin = this.handleChangeFormLogin.bind(this)
        this._recaptchaRefLogin = React.createRef();

        
        this.formCartSubmit = this.formCartSubmit.bind(this)
        this.handleChangeFormCart = this.handleChangeFormCart.bind(this)
        this._recaptchaRefCart = React.createRef();
        this.onChangeCityCart = this.onChangeCityCart.bind(this)

        this.plusMore = this.plusMore.bind(this)
        this.plusLess = this.plusLess.bind(this)

        this.deleteG = this.deleteG.bind(this)

        this.goShop = this.goShop.bind(this);

        this.changeAddress = this.changeAddress.bind(this);

        this.onSubmitAddress = this.onSubmitAddress.bind(this);
        this.handleChangeFormAddress = this.handleChangeFormAddress.bind(this);
        this.onChangeAddressCity = this.onChangeAddressCity.bind(this);

        this.selectAddress = this.selectAddress.bind(this);

        this.onSubmitAddressAdd = this.onSubmitAddressAdd.bind(this);
        this.onChangeAddressAdd = this.onChangeAddressAdd.bind(this);
        this.onChangeAddressCityAdd = this.onChangeAddressCityAdd.bind(this);
    }

    //register_form started
    handleChangeFormRegister(e){
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                [e.target.name]:e.target.value
            }
        })
    }
    
    onChangeCountry(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                country_id:e.target.value,
            }
        });
        /*
        try{
            let config = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formRegister)
            }
            let res = await fetch(`${https}api/statesGet`,config)
            let data = await res.json();
            this.setState({
                states:data
            });
            fetch(`${https}api/statesGet`)
                .then(res => res.json())
                .then(res => {
                    this.setState({
                        states: res,
                    });
                });
        }catch (error) {
            this.setState({
                error
            })
        }
        */
    }

    onChangeState(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                state_id:e.target.value,
            }
        });
    }

    onChangeCity(e){
        this.setState({city: e.target.value});
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                city_id:e.target.value,
            }
        });
    }

    formRegisterSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formRegister.name == '' ||
            this.state.formRegister.lastname == '' ||
            //this.state.formRegister.identy == '' ||
            this.state.formRegister.mail == '' ||
            this.state.formRegister.password == '' ||
            this.state.formRegister.phone == '' ||
            this.state.formRegister.address == ''||
            this.state.formRegister.town == '' ||
            this.state.formRegister.city_id == ''||
            this.state.formRegister.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        const tokenRegister = await this._recaptchaRefRegister.current.executeAsync();
        this.setState({
            formRegister:{
                ...this.state.formRegister,
                token: tokenRegister
            }
        });

        if(!tokenRegister){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }
        try{
            let configRegister = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formRegister)
            }
            let resRegister = await fetch(`${https}api/register`,configRegister)
            let dataRegister = await resRegister.json()
            if(dataRegister == 1){
                this.setState({
                    formRegister:{
                        name:'',
                        lastname:'',
                        identy:'',
                        mail:'',
                        password:'',
                        phone:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formRegister").reset();
                $("#formRegister")[0].reset();
                swal({
                    text: "Gracias por registrarse, pronto nos contactaremos con usted",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataRegister == 2) {
                swal({
                    text: "Este usuario ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //register_form finished

    forget = async (e) =>{
        e.preventDefault()
        if(
            this.state.formLogin.user == ''
        ){
            swal({
                text: "Debes digitar el correo electronico",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configForget = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resForget = await fetch(`${https}api/forget`,configForget)
            let dataForget = await resForget.json()
            if(dataForget == 1){
                swal({
                    text: "Se ha enviado un correo a "+this.state.formLogin.user,
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 3) {
                swal({
                    text: "Usuario no registrado",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataForget == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                //console.log(dataForget);
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    handleChangeFormLogin(e){
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                [e.target.name]:e.target.value
            }
        })
    }
    
    formLoginSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formLogin.user == '' ||
            this.state.formLogin.password == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        /*const token = await this._recaptchaRefLogin.current.executeAsync();
        this.setState({
            formLogin:{
                ...this.state.formLogin,
                token: token
            }
        });
        if(!token){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }*/
        try{
            let configLogin = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resLogin = await fetch(`${https}api/login`,configLogin)
            let dataLogin = await resLogin.json()
            if(dataLogin == 1){
                this.setState({
                    formLogin:{
                        user:'',
                        password:'',
                        token:'',
                    }
                })
                //document.getElementById("formLogin").reset();
                location.reload();
            }else if(dataLogin == 2) {
                swal({
                    text: "Error de recaptcha",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 3) {
                swal({
                    text: "Usuario o contraseña incorrecta",
                    icon: "warning",
                    button: "OK!",
                });
            }else if(dataLogin == 4){
                swal({
                    text: "Su usuario no tiene los permisos necesarios para acceder",
                    icon: "warning",
                    button: "OK!",
                });
            }else{
                alert('ocurrio un error');
                setTimeout(function (){
                    location.reload();
                },1000)
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //cart_form started
    handleChangeFormCart(e){
        this.setState({
            formCart:{
                ...this.state.formCart,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeCityCart(e){
        this.setState({
            formCart:{
                ...this.state.formCart,
                city_id:e.target.value,
            }
        });
    }

    formCartSubmit = async (e) => {
        e.preventDefault()
        if(
            this.state.formCart.name == '' ||
            this.state.formCart.lastname == '' ||
            //this.state.formCart.identy == '' ||
            this.state.formCart.mail == '' ||
            //this.state.formCart.password == '' ||
            this.state.formCart.phone == '' ||
            this.state.formCart.address == ''||
            this.state.formCart.town == '' ||
            this.state.formCart.city_id == '' ||
            this.state.formCart.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        /*const tokenCart = await this._recaptchaRefCart.current.executeAsync();
        this.setState({
            formCart:{
                ...this.state.formCart,
                token: tokenCart
            }
        });

        if(!tokenCart){
            swal({
                text: "Error, eres un robot",
                icon: "warning",
                button: "OK!",
                closeOnClickOutside: false,
            });
            return false;
        }*/
        try{
            let configCart = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formCart)
            }
            let resCart = await fetch(`${https}api/registerShop`,configCart)
            let dataCart = await resCart.json()
            if(dataCart == 1){
                this.setState({
                    formCart:{
                        name:'',
                        lastname:'',
                        identy:'',
                        mail:'',
                        password:'',
                        phone:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formCart").reset();
                $("#formCart")[0].reset();
                swal({
                    text: "Gracias por continuar con la compra",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataCart == 2) {
                swal({
                    text: "Gracias por continuar con la compra",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                .then((willDelete) => {
                    if (willDelete) {
                        location.reload();
                    } else {

                    }
                });
                /*swal({
                    text: "Este usuario ya se encuentra registrado",
                    icon: "warning",
                    button: "OK!",
                });*/
            }else{
                alert('ocurrio un error');
                console.log(data);
                /*setTimeout(function (){
                    location.reload();
                },1000)*/
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //cart_form finished

    plusMore = async (id) =>{
        let product_id = $('#plusmore_'+id).attr('product_id');
        let version_id = $('#plusmore_'+id).attr('version_id');
        let cant = $('#cant_'+id).html();
        var canti = parseInt(cant) + 1;
        $('#cant_'+id).html(canti);
        try{
            fetch(https+'api/changeCantCart/'+product_id+'/'+version_id+'/'+canti)
                .then(response => response.json())
                .then(data =>{
                    if(data == 1){
                        location.reload();
                    }else{
                        alert('ocurrio un error');
                        setTimeout(function (){
                            location.reload();
                        },1000)
                    }
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    plusLess = async (id) =>{
        let product_id = $('#plusless_'+id).attr('product_id');
        let version_id = $('#plusless_'+id).attr('version_id');
        let cant = $('#cant_'+id).html();
        var canti = parseInt(cant) - 1;
        if(canti <= 1){
            canti = 1;
        }
        $('#cant_'+id).html(canti);
        try{
            fetch(https+'api/changeCantCart/'+product_id+'/'+version_id+'/'+canti)
                .then(response => response.json())
                .then(data =>{
                    if(data == 1){
                        location.reload();
                    }else{
                        alert('ocurrio un error');
                        setTimeout(function (){
                            location.reload();
                        },1000)
                    }
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    deleteG(id){
        swal({
            title: "¿Seguro de hacer esto?",
            text: "El producto se borrara de tu carrito de compras",
            icon: "warning",
            buttons: true,
            dangerMode: true,
            closeOnClickOutside: false,
        })
        .then((willDelete) => {
            if (willDelete) {
                let product_id = $('#delete_'+id).attr('product_id');
                let version_id = $('#delete_'+id).attr('version_id');
                try{
                    fetch(https+'api/delete/'+product_id+'/'+version_id)
                        .then(response => response.json())
                        .then(data =>{
                            if(data == 1){
                                location.reload();
                            }else{
                                alert('ocurrio un error');
                                setTimeout(function (){
                                    location.reload();
                                },1000)
                            }
                        })
                }catch (error) {
                    this.setState({
                        error
                    })
                }
            } else {
                return false;
            }
        });
        
    }

    goShop = async () =>{

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configGoShop = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formLogin)
            }
            let resGoShop = await fetch(`${https}api/goShop`,configGoShop)
            let dataGoShop = await resGoShop.json()
            if(dataGoShop == 1){
                swal({
                    title: "Muchas gracias",
                    text: "redirigiendo a pasarela de pago",
                    icon: "success",
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                .then((willDelete) => {
                    if (willDelete) { 
                        location.href = https+'payu';
                    }else {
                    }
                });
            }else if(dataGoShop == 2){
                swal({
                    text: "Un producto esta agotado",
                    icon: imageURL,
                    button: "OK!",
                    closeOnClickOutside: false,
                });
            }else{
                swal({
                    text: dataGoShop,
                    icon: imageURL,
                    button: "OK!",
                    closeOnClickOutside: false,
                });
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    changeAddress = async (id,city_id) =>{
        this.setState({
            city_id:city_id,
        })
        if( !$("#address_"+id).is(':checked') ){
            id = 0;
            $("input[name=address_id]").prop('checked', false);
            $("#address_"+id).prop('checked', false);
        }else{
            $("input[name=address_id]").prop('checked', false);
            $("#address_"+id).prop('checked', true);
        }
        try{
            fetch(https+'api/addressListSelect/'+id)
                .then(response => response.json())
                .then(data =>{
                    if(id != 0){
                        this.setState({
                            shipping:data,
                        })
                    }
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //address_form started
    handleChangeFormAddress(e){
        this.setState({
            formAddress:{
                ...this.state.formAddress,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeAddressCity(e){
        this.setState({
            formAddress:{
                ...this.state.formAddress,
                city_id:e.target.value,
            }
        });
    }

    onSubmitAddress = async (e) => {
        e.preventDefault()
        if(
            this.state.formAddress.password == '' ||
            this.state.formAddress.address == ''||
            this.state.formAddress.town == '' ||
            this.state.formAddress.city_id == '' ||
            this.state.formAddress.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configAddress = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formAddress)
            }
            let resAddress = await fetch(`${https}api/addressListUpdateGo`,configAddress)
            let dataAddress = await resAddress.json()
            if(dataAddress == 1){
                this.setState({
                    formAddress:{
                        id:'',
                        password:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formAddress").reset();
                $("#formAddress")[0].reset();
                swal({
                    text: "Gracias por actualizar la direccion",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataAddress == 2){
                swal({
                    text: "Contraseña incorrecta, no se ha podido actualizar la dirreción",
                    icon: "warning",
                    button: "ok",
                });
            }else{
                alert('ocurrio un error');
                /*setTimeout(function (){
                    location.reload();
                },1000)*/
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //address_form finished

    selectAddress = async (id) =>{
        try{
            fetch(https+'api/addressListUpdate/'+id)
                .then(response => response.json())
                .then(data =>{
                    this.setState({
                        formAddress:{
                            id: data.id,
                            password:'',
                            address:data.address,
                            town:data.town,
                            token:'',
                            country_id:'',
                            state_id:'',
                            city_id:data.city,
                            description:data.description
                        },
                    })
                })
        }catch (error) {
            this.setState({
                error
            })
        }
    }

    //address_add_form started
    onChangeAddressAdd(e){
        this.setState({
            formAddressAdd:{
                ...this.state.formAddressAdd,
                [e.target.name]:e.target.value
            }
        })
    }

    onChangeAddressCityAdd(e){
        this.setState({
            formAddressAdd:{
                ...this.state.formAddressAdd,
                city_id:e.target.value,
            }
        });
    }

    onSubmitAddressAdd = async (e) => {
        e.preventDefault()
        if(
            this.state.formAddressAdd.password == '' ||
            this.state.formAddressAdd.address == ''||
            this.state.formAddressAdd.town == '' ||
            this.state.formAddressAdd.city_id == '' ||
            this.state.formAddressAdd.description == ''
        ){
            swal({
                text: "Debes digitar todos los datos",
                icon: imageURL,
                button: "OK!",
            });
            return false;
        }

        swal({
            text: "Espere un momento",
            icon: imageURL,
            button: false,
            closeOnClickOutside: false,
        });

        try{
            let configAddressAdd = {
                method: 'POST',
                headers:{
                    'Accept':'application/json',
                    'Content-Type':'application/json'
                },
                body: JSON.stringify(this.state.formAddressAdd)
            }
            let resAddressAdd = await fetch(`${https}api/addressListAdd`,configAddressAdd)
            let dataAddressAdd = await resAddressAdd.json()
            if(dataAddressAdd == 1){
                this.setState({
                    formAddressAdd:{
                        id:'',
                        password:'',
                        address:'',
                        town:'',
                        token:'',
                        country_id:'',
                        state_id:'',
                        city_id:'',
                        description:''
                    },
                })
                swal.close();
                document.getElementById("formAddressAdd").reset();
                $("#formAddressAdd")[0].reset();
                swal({
                    text: "Gracias por agregar la direccion",
                    icon: imageURL,
                    button: "OK!",
                    dangerMode: false,
                    closeOnClickOutside: false,
                })
                    .then((willDelete) => {
                        if (willDelete) {
                            location.reload();
                        } else {

                        }
                    });
            }else if(dataAddressAdd == 2){
                swal({
                    text: "Contraseña incorrecta, no se ha podido agregar la dirreción",
                    icon: "warning",
                    button: "ok",
                });
            }else{
                alert('ocurrio un error');
                /*setTimeout(function (){
                    location.reload();
                },1000)*/
            }
        }catch (error) {
            this.setState({
                error
            })
        }
    }
    //address_form finished

    async componentDidMount(){
        //products_cart
        try{
            //console.log('=====================');
            let res = await fetch(https+'api/productsCart')
            let data = await res.json()
            this.setState({
                products_cart:data,
            })
            //console.log('=====================');
            //console.log(this.state.products_cart);
            //console.log(cantCart);
            //console.log(this.state.products_cart[0][1].img);
            //console.log('=====================');
            for(var i = 1; i<= cantCart;i++) {
                //console.log(i);
                this.setState({
                    products:{
                        ...this.state.products,
                        [i]:{
                            id:i,
                            product_id:this.state.products_cart[0][i].product_id,
                            version_id:this.state.products_cart[0][i].version_id,
                            img:this.state.products_cart[0][i].img,
                            name:this.state.products_cart[0][i].name,
                            version:this.state.products_cart[0][i].version,
                            price:this.state.products_cart[0][i].price,
                            cant:this.state.products_cart[0][i].cant,
                            subtotal:this.state.products_cart[0][i].subtotal,
                        }
                    },
                })
                //console.log(this.state.products_cart[0][i].img);
            }
            //console.log(this.state.products);
            //console.log('=====================');
        }catch (error) {
            this.setState({
                error
            })
        }
        //envio
        try{
            let res = await fetch(https+'api/shipping')
            let data = await res.json()
            this.setState({
                shipping:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //address
        try{
            let res = await fetch(https+'api/addressList')
            let data = await res.json()
            this.setState({
                addressList:data,
            })
            this.setState({
                formAddress:{
                    id: data[0].id,
                    password:'',
                    address:data[0].address,
                    town:data[0].town,
                    token:'',
                    country_id:'',
                    state_id:'',
                    city_id:data[0].city,
                    description:data[0].description
                },
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //informacion
        try{
            let res = await fetch(https+'api/info')
            let data = await res.json()
            this.setState({
                info:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands
        try{
            let res = await fetch(https+'api/brandsHeader')
            let data = await res.json()
            this.setState({
                brands:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //brands 2
        try{
            let res = await fetch(https+'api/brandsHeader2')
            let data = await res.json()
            this.setState({
                brands_2:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //categories
        try{
            let res = await fetch(https+'api/categoriesHeader')
            let data = await res.json()
            this.setState({
                categories:data,
            })
        }catch (error) {
            this.setState({
                error
            })
        }
        //city
        try{
            let res = await fetch(https+'api/cities')
            let data = await res.json()
            this.setState({
                cities:data
            })
        }catch (error) {
            this.setState({
                error
            })
        }

    }

    render() {
        return (
            <div>
                <Header
                    brands={this.state.brands}
                    brands_2={this.state.brands_2}
                    categories={this.state.categories}
                />
                <Info
                    products_cart={this.state.products_cart}
                    products={this.state.products}
                    
                    form={this.state.formCart}
                    onChange={this.handleChangeFormCart}
                    onSubmit={this.formCartSubmit}
                    recaptchaRefCart={this._recaptchaRefCart}
                    onChangeCity={this.onChangeCityCart}
                    cities={this.state.cities}

                    shipping={this.state.shipping}

                    plusMore={this.plusMore}
                    plusLess={this.plusLess}

                    deleteG={this.deleteG}

                    goShop={this.goShop}

                    addressList={this.state.addressList}
                    changeAddress={this.changeAddress}
                    
                    onSubmitAddress={this.onSubmitAddress}
                    formAddress={this.state.formAddress}
                    onChangeAddress={this.handleChangeFormAddress}
                    onChangeAddressCity={this.onChangeAddressCity}

                    selectAddress={this.selectAddress}

                    onSubmitAddressAdd={this.onSubmitAddressAdd}
                    formAddressAdd={this.state.formAddressAdd}
                    onChangeAddressAdd={this.onChangeAddressAdd}
                    onChangeAddressCityAdd={this.onChangeAddressCityAdd}

                    city_id={this.state.city_id}
                />
                <Float
                    info={this.state.info}
                />
                <Modals
                    form={this.state.formRegister}
                    onChange={this.handleChangeFormRegister}
                    onSubmit={this.formRegisterSubmit}
                    recaptchaRefRegister={this._recaptchaRefRegister}
                    onChangeCountry={this.onChangeCountry}
                    onChangeState={this.onChangeState}
                    onChangeCity={this.onChangeCity}
                    cities={this.state.cities}
                    forget={this.forget}
                    formlogin={this.state.formLogin}
                    onChangeLogin={this.handleChangeFormLogin}
                    recaptchaRefLogin={this._recaptchaRefLogin}
                    onSubmitLogin={this.formLoginSubmit}
                />
                <Footer
                    info={this.state.info}
                />
            </div>
        );
    }

}

if (document.getElementById('content_cart')) {
    ReactDOM.render(<Cart />, document.getElementById('content_cart'))
}